<template>
  <div class="MapUrlConfiger">
    <div class="p-name">地图地址</div>
    <div class="p-key">
      <el-input size="mini" v-model="value" placeholder=""></el-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MapUrlConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    value: {
      deep: true,
      handler: function (newVal) {
        this.commitCurrentPropertyData(newVal);
      },
    },
  },
  data() {
    return {
      value: '',
    };
  },
  created() {
    this.initCurrentPropertyData();
  },
  mounted() {
    /* 获取初始值 */
    // this.keyValue = this.propertyData.MapKey.value;
  },
  methods: {
    initCurrentPropertyData() {
      this.value = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
    },
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.MapUrlConfiger {
  margin-top: 10px;
  align-items: center;
  width: 100%;
  display: flex;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    display: inline-block;
    width: 80px;
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
  .p-key {
    /* margin: 5px 0; */
    color: #71717c;
    font-size: 12px;
    display: inline-block;
    height: 30px;
    width: 65%;
    /* // padding: 0 15px; */
    align-items: center;
    justify-content: space-between;

    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    .el-input {
      width: 100%;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
